// 腾讯地图KEY
export const mapKey = "";

// API基础地址
export const baseRequestUrl = 'https://pms.suanju.net/api';
